import React from "react";

import { useImportContext } from "../importContext";
import { ExcelImportWizard } from "./ExcelImportWizard";
import { KMLImportWizard } from "./KMLImportWizard";
import { ShapeImportWizard } from "./ShapeImportWizard";
import { GDBImportWizard } from "./GDBImportWizard";
import { ImportType } from "../types";

export const ImportWizard = () => {
  const { importType } = useImportContext();

  switch (importType) {
    case ImportType.KML:
      return <KMLImportWizard />;
    case ImportType.XLSX:
      return <ExcelImportWizard />;
    case ImportType.SHAPE:
      return <ShapeImportWizard />;
    case ImportType.GDB:
      return <GDBImportWizard />;
    default:
      return <ShapeImportWizard />;
  }
};
